/*配置文件*/
export default {
    baseUrl: {
        dev: '/api',
        pro: 'https://fengling.work/api'
    }
}
